import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Service } from './service.interface';
import { isNullOrUndefined } from 'util';
import { Response } from '../entities/response';
import { AuthService } from './auth.service';
import { Configuracion } from '../entities/configuracion';

@Injectable({
    providedIn: 'root'
  })
  
export class ConfiguracionService extends Service {

    constructor(
        private _http: HttpClient,
        private authService: AuthService ) {
        super(_http, environment.baseURLsage);
    }

    async getConfiguracion():Promise<Configuracion> {
      //return this.get<any>('http://localhost:9998/configuracion');
      return new Promise<Configuracion>(resolve=>{
        this._http.get(`${environment.baseURL}configuracion`)
        .subscribe((resp:Configuracion)=>{
          resolve(resp);
        })
      })
    }
    
}